import React, { useState } from "react";
import axios from "axios";
import config from "react-global-configuration";
import { Card, Label, Input, Button, Progress } from "reactstrap";
import CommonNavbar from "./commonNavbar";

const AdminUploadExcel = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [result, setResult] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!file) {
      alert("Please select an Excel file.");
      return;
    }

    setUploading(true);
    setProgress(0);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${config.get("API_URL")}/brandemi/upload-sku-excel`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: ` ${localStorage.usertoken}`,
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
          },
        }
      );

      setResult(response.data.data);

    } catch (error) {
      console.error("Error uploading file:", error);
      setResult({
        error: "Failed to upload file",
        details: error.response ? error.response.data : error.message,
      });
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="content longcontent">
      <CommonNavbar />
      <Card className="p-4 m-4">
        <h4>Upload Excel File for SKU Update</h4>
        <div className="mb-3">
          <Label>Select Excel File</Label>
          <Input type="file" accept=".xls,.xlsx" onChange={handleFileChange} />
        </div>
        <Button color="primary" onClick={handleSubmit} disabled={uploading}>
          {uploading ? "Uploading..." : "Upload File"}
        </Button>

        {result && (
          <div className="mt-3">
            <h5>Upload Summary</h5>
            <pre>{JSON.stringify(result, null, 2)}</pre>
          </div>
        )}
      </Card>
    </div>
  );
};

export default AdminUploadExcel;
